<template>
  <div>
    <h1 class="show-in-mobile">Zonas</h1>
    <div class="filter-container" style="margin-bottom:10px; text-align:left">
      <span style="margin-right: 10px">Filtrar</span>
      <el-input
        v-model="search"
        size="mini"
        placeholder="Nombre"
        style="width: 150px; margin-right:5px"
      />
      <el-button
        v-if="hasPermission('edit')"
        class="filter-item"
        type="primary"
        icon="el-icon-download"
        size="mini"
        @click="handleDownload"
        :loading="loadingExportButton"
      >
        <span v-if="!is_mobile">Exportar</span>
      </el-button>
      <el-button
        v-if="hasPermission('edit')"
        class="filter-item"
        style="margin-left: 10px;"
        type="primary"
        icon="el-icon-plus"
        size="mini"
        @click="handleCreate"
      >
        <span v-if="!is_mobile">Nueva zona</span>
      </el-button>
    </div>
    <el-table
      v-loading="loading"
      element-loading-text="Cargando..."
      :data="zoneList.filter(data => !search || data.name.toLowerCase().includes(searchInLowerCase))"
      ref="zoneListFiltered"
      :default-sort="{prop: 'name', order: 'ascending'}"
      @row-dblclick="handleView"
      style="width: 100%"
    >
      <el-table-column
        prop="status"
        label="Estado"
        width="100"
        :filters="[{ text: 'Inactiva', value: false }, { text: 'Activa', value: true }]"
        :filter-method="filterStatus"
        filter-placement="bottom-end"
      >
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.is_active ? 'success' : 'danger'"
            @click="handleStatus(scope.row)"
            style="cursor:pointer;"
            disable-transitions
          >{{scope.row.is_active ? 'Activa' : 'Inactiva'}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Nombre" prop="name" sortable min-width="200"></el-table-column>
      <el-table-column label="Descripción" prop="desc" min-width="200"></el-table-column>
      <el-table-column align="right" min-width="120">
        <template slot-scope="scope">
          <el-button v-if="hasPermission('edit')" size="mini" @click="handleEdit(scope.row)" icon="el-icon-edit" />
          <el-button
            v-if="hasPermission('all')"
            size="mini"
            type="danger"
            @click="handleDelete(scope.row)"
            icon="el-icon-delete"
          />
        </template>
      </el-table-column>
    </el-table>

    <!-- Form -->
    <el-dialog
      :title="modal.name"
      :visible.sync="dialogFormVisible"
      width="60%"
      @close="handleDialogClose()"
    >
      <el-form :model="form" ref="form" :label-width="formLabelWidth">
        <el-row>
          
          <el-col :xs="24" :md="8">
            <el-form-item label="Nombre" prop="name"
            :rules="{ required: true, message: 'Debe ingresar un valor', trigger: 'blur' }">
              <el-input v-model="form.name" autocomplete="off" :disabled="modal.readOnly || modal.status == 'edit'"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="11">
            <el-form-item label="Descripción">
              <el-input type="textarea" v-model="form.desc" :disabled="modal.readOnly"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="4">
            <el-form-item label="Estado" style="text-align:left">
              <el-switch v-model="form.is_active" :disabled="modal.readOnly"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="8" :sm="12" v-for="option in options" :key="option.value">
            <div><h4>{{option.label}}</h4></div>
            <el-form-item label="Mínimo" :prop="option.value+'_'+unit.value" style="text-align:left" v-for="unit in option.unit" :key="unit.value"
            :rules="{ required: true, message: 'Debe ingresar un valor', trigger: 'blur' }">
              <el-input v-model="form[option.value+'_'+unit.value]" :disabled="modal.readOnly" autocomplete="off" style="width:70px"></el-input> {{unit.label}}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer" v-if="!modal.readOnly">
        <el-button @click="dialogFormVisible = false">Cancelar</el-button>
        <el-button :loading="loadingSaveButton" type="primary" @click="handleSaveButton('form')">Guardar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

export default {
  data() {
    return {
      loading: false,
      loadingExportButton: false,
      loadingSaveButton: false,
      search: "",
      dialogFormVisible: false,
      form: {
        name: '',
        desc: '',
        is_active: true
      },
      formLabelWidth: "95px",
      modal: {
        name: "",
        status: "",
        readOnly: false,
      }
    };
  },
  async created() {
    this.$store.commit("CHANGE_SECTION", { name: "Zonas", index: "3" });

    this.loading = true;
    await this.$store.dispatch("getZones");
    this.loading = false;
  },
  methods: {
    hasPermission( permissionReq ) {
      return this.$store.getters.hasPermission('Zones', permissionReq)
    },
    msgSuccess(text){
      this.$message({
        type: "success",
        message: text
      });
    },
    msgError(text) {
      this.$message({
        type: "error",
        showClose: true,
        duration: 0,
        message: text
      });
    },
    filterStatus(value, row) {
      return row.is_active === value;
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    handleView(row, column, event) {
      this.modal = { name: "Ver Zona", status: "view", readOnly: true };
      this.form = { ...row };
      this.dialogFormVisible = true;
    },
    handleCreate() {
      if( this.hasPermission('edit') ) {
        this.modal = { name: "Nueva Zona", status: "add", readOnly: false };
        this.dialogFormVisible = true;
      }
    },
    handleEdit(row) {
      if( this.hasPermission('edit') ) {
        this.modal = { name: "Editar Zona", status: "edit", readOnly: false };
        this.form = { ...row };
        this.dialogFormVisible = true;
      }
    },
    handleSaveButton(formName) {
      this.$refs[formName].validate( async valid => {
        if (valid) { // Valid form
          this.loadingSaveButton = true
          if (this.modal.status === "add") {
            await this.$store.dispatch("addZone", {...this.form})
            .then(() => {
              this.msgSuccess("La zona fue agregada")
            })
            .catch(() => {
              this.msgError("Hubo un error agregando la zona")
            })
            
          } else {
            await this.$store.dispatch("updateZone", {...this.form})
            .then(() => {
              this.msgSuccess("La zona fue actualizada")
            })
            .catch(() => {
              this.msgError("Error actualizando la zona, probablemente ya no exista en la base de datos. Recargue la página")
            })
          }
          this.loadingSaveButton = false
          this.dialogFormVisible = false
        }
      });
    },
    handleDialogClose() {
      // Reset form validations
      this.$refs["form"].resetFields();
      this.form = {}
      this.form.is_active = true
      //this.$refs['form'].clearValidate(['name', 'solid', 'water', 'oil', 'other']);
    },
    handleDelete(row) {
      if( this.hasPermission('all') ) {
        this.$confirm(
          "Estás por borrar completamente la zona " + row.name,
          "Borrar",
          {
            confirmButtonText: "Borrar",
            cancelButtonText: "Cancelar",
            type: "warning"
          }
        )
        .then(() => {
          this.$store.dispatch("deleteZone", row)
          .then(() => {
            this.msgSuccess("La zona fue eliminada")
          })
          .catch(() => {
            this.msgError("Error eliminando la zona")
          })
        })
        .catch(() => {})
      }
    },
    handleStatus(row) {
      if( this.hasPermission('edit') ) {
        const statusText = row.is_active ? "Desactivar" : "Activar";
        this.$confirm(
          "Desea " + statusText.toLowerCase() + " la zona " + row.name,
          statusText,
          {
            confirmButtonText: statusText,
            cancelButtonText: "Cancelar",
            type: "warning"
          }
        )
          .then(() => {
            this.$store.dispatch("toggleStatusZone", row)
            .then(() => {
              this.msgSuccess("La zona fue actualizada")
            })
            .catch(() => {
              this.msgError("Error actualizando la zona, probablemente ya no exista en la base de datos. Recargue la página")
            })
          }).catch(() => {})
      }
    },
    handleDownload() {
      this.loadingExportButton = true;
      import("@/vendor/Export2Excel").then(excel => {
        const tHeader = [
          "Estado",
          "Nombre",
          "Descripción",
        ];
        const filterVal = [
          "is_active",
          "name",
          "desc",
        ];
        this.options.forEach( option => {
          option.unit.forEach( unit => {
            tHeader.push(option.label + ' - ' + unit.label )
            filterVal.push(option.value + '_' + unit.value )
          })
        })
        const data = this.formatJson(filterVal);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "zonas"
        });
        this.loadingExportButton = false;
      });
    },
    formatJson(filterVal) {
      // Export only visible elements, if use filter, only export filtered elements
      return this.$refs.zoneListFiltered.tableData.map(v =>
        filterVal.map(j => {
          if (j === "is_active") {
            return v.is_active ? "Activa" : "Inactiva";
          } else {
            return v[j];
          }
        })
      );
    }
  },
  computed: {
    searchInLowerCase() {
      return this.search.toLowerCase().trim();
    },
    is_mobile() {
      return this.$store.state.is_mobile;
    },
    zoneList() {
      return this.$store.state.zones.zoneList;
    },
    options() {
      let options = []
      this.$store.state.orders.options.forEach( e => {
        options.push(e)
      })
      /* options.push(
        {
          label: 'Otros', 
          value: 'others', 
          unit: [
                  {
                    label: 'Tambor/es',
                    value: 'drum'
                  },
                ]
        }) */

      // Order by name
      options.sort(function(a, b) {
        var nameA = a.label.toUpperCase(); // ignore upper and lowercase
        var nameB = b.label.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        // names must be equal
        return 0;
      });
      return options
    },
  }
};
</script>